import React from 'react';
import { useTranslation } from 'react-i18next';
import OrgDetailSection from './OrgDetailSection';

interface OrgPublicPlanSectionProps {
    value: boolean;
    onChange: (value: boolean) => void;
    /** Render read-only (view mode). */
    disabled?: boolean;
}

/**
 * D3b — whether this organisation may appear by name on the public plan
 * (`organization.show_on_public_plan`, default off). The flag governs every
 * non-member, signed in or not: off, its bookings read "belegt" to everyone
 * outside the organisation on the room week view and the public plan; on, its
 * name shows to everyone. Members always see their own organisation.
 *
 * Same labelled native checkbox as the other boolean settings on the
 * Tailwind screens (`PaymentProviderSection`, `CategoryConfigForm`).
 */
const OrgPublicPlanSection: React.FC<OrgPublicPlanSectionProps> = ({ value, onChange, disabled = false }) => {
    const { t } = useTranslation();
    return (
        <OrgDetailSection title={t('organization.sections.public_plan')}>
            <label className={'flex items-start gap-2 text-sm text-foreground'}>
                <input
                    type={'checkbox'}
                    className={'mt-1 h-4 w-4 accent-primary'}
                    checked={value === true}
                    disabled={disabled}
                    onChange={(event) => onChange(event.target.checked)}
                />
                <span>
                    {t('organization.fields.show_on_public_plan')}
                    <span className={'block text-xs text-foreground/60'}>
                        {t('organization.help.show_on_public_plan')}
                    </span>
                </span>
            </label>
        </OrgDetailSection>
    );
};

export default OrgPublicPlanSection;
